export const afterGameTypes = {
	SET_AFTER_TAB: 'SET_ACTIVE_TAB',
};

export const setAfterGameTab = (payload) => ({
	type: afterGameTypes.SET_AFTER_TAB,
	payload,
});
